import { each, cloneDeep } from 'lodash';

import { formatDateUTCWithoutTime, formatAsLocalizedDateIgnoringTZ } from 'utils/date';

export function parseStep3DatesAsUTCWithoutTime(content) {
    // medicationAdherenceReviewDate will be stripped on saving but could be in content saved on v1
    if (content?.medicationAdherenceReviewDate) {
        content.medicationAdherenceReviewDate = formatAsLocalizedDateIgnoringTZ(content.medicationAdherenceReviewDate);
    }
}

export function cloneAndformatStep3DatesAsUTCWithoutTime(content) {
    const clonedContent = cloneDeep(content);

    // medicationAdherenceReviewDate will be stripped on saving but could be in content saved on v1
    if (content?.medicationAdherenceReviewDate) {
        content.medicationAdherenceReviewDate = formatDateUTCWithoutTime(content.medicationAdherenceReviewDate);
    }

    return clonedContent;
}

export function parseStep4DatesAsUTCWithoutTime(content) {
    each(content.vitals, (row) => {
        if (row?.date) {
            row.date = formatAsLocalizedDateIgnoringTZ(row.date);
        }
    });
}

export function formatStep4DatesAsUTCWithoutTime(content) {
    const clonedContent = cloneDeep(content);
    each(clonedContent.vitals, (row) => {
        if (row?.date) {
            row.date = formatDateUTCWithoutTime(row.date);
        }
    });

    return clonedContent;
}

export function parseStep5DatesAsUTCWithoutTime(content) {
    each(content.labs, (row) => {
        if (row?.date) {
            row.date = formatAsLocalizedDateIgnoringTZ(row.date);
        }
    });
}

export function formatStep5DatesAsUTCWithoutTime(content) {
    const clonedContent = cloneDeep(content);

    each(clonedContent.labs, (row) => {
        if (row?.date) {
            row.date = formatDateUTCWithoutTime(row.date);
        }
    });

    return clonedContent;
}

export function parseStep6DatesAsUTCWithoutTime(content) {
    each(content.imaging, (row) => {
        if (row?.date) {
            row.date = formatAsLocalizedDateIgnoringTZ(row.date);
        }
    });
}

export function formatStep6DatesAsUTCWithoutTime(content) {
    const clonedContent = cloneDeep(content);

    each(clonedContent.imaging, (row) => {
        if (row?.date) {
            row.date = formatDateUTCWithoutTime(row.date);
        }
    });

    return clonedContent;
}

export function parseStep7DatesAsUTCWithoutTime(content) {
    each(content.screening, (row) => {
        if (row?.lastDateCompleted) {
            row.lastDateCompleted = formatAsLocalizedDateIgnoringTZ(row.lastDateCompleted);
        }
    });
}

export function formatStep7DatesAsUTCWithoutTime(content) {
    const clonedContent = cloneDeep(content);

    each(clonedContent.screening, (row) => {
        if (row?.lastDateCompleted) {
            row.lastDateCompleted = formatDateUTCWithoutTime(row.lastDateCompleted);
        }
    });

    return clonedContent;
}

export function parseStep10DatesAsUTCWithoutTime(content) {
    each(content.referrals, (row) => {
        if (row?.date) {
            row.date = formatAsLocalizedDateIgnoringTZ(row.date);
        }
    });
}

export function formatStep10DatesAsUTCWithoutTime(content) {
    const clonedContent = cloneDeep(content);

    each(clonedContent.referrals, (row) => {
        if (row?.date) {
            row.date = formatDateUTCWithoutTime(row.date);
        }
    });

    return clonedContent;
}
